import React from 'react';
import { Button } from './ui/button';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_hire-platform-22/artifacts/01uzdzol_LOGO%20AMAIA.jpg';

const Navbar = ({ onSignIn, onSignUp }) => {
  return (
    <header className="sticky top-0 z-40 w-full border-b border-neutral-200/60 bg-white/80 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6">
        <a href="/" className="flex items-center gap-2">
          <img
            src={LOGO_URL}
            alt="AMAIA.CLOUD — Augmented Mankind Abilities powered by AI"
            className="h-8 w-auto object-contain"
          />
          <span className="ml-1 rounded-md bg-neutral-100 px-1.5 py-0.5 text-[11px] font-medium text-neutral-600">Hire</span>
        </a>

        <nav className="hidden items-center gap-8 md:flex">
          <a href="/#roster" className="text-sm text-neutral-600 transition-colors hover:text-neutral-900">Workers</a>
          <a href="/workspace" className="text-sm text-neutral-600 transition-colors hover:text-neutral-900">Workspace</a>
          <a href="/pricing" className="text-sm text-neutral-600 transition-colors hover:text-neutral-900">Pricing</a>
          <a href="/legal" className="text-sm text-neutral-600 transition-colors hover:text-neutral-900">Legal</a>
        </nav>

        <div className="flex items-center gap-2">
          <Button variant="ghost" size="sm" onClick={onSignIn} className="text-neutral-700 hover:text-neutral-900">Sign in</Button>
          <Button size="sm" onClick={onSignUp} className="bg-neutral-900 text-white hover:bg-neutral-800">Sign up</Button>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
